import { Extension } from '@tiptap/core';

const getParent = (vueNode) => {
    let iterator = 0;
    let parent = vueNode.$parent;

    while (
        parent &&
        !parent.$refs.refEmailPanelRichText &&
        !parent.$refs.refSettingsEmailsTemplatesFormRichTextMessage &&
        iterator < 5
    ) {
        parent = parent?.$parent;
        iterator++;
    }

    return parent;
};

const CustomSellsyAI = Extension.create({
    name: 'customSellsyAI',
    addKeyboardShortcuts() {
        return {
            Space: (event) => {
                const currentNodeContent =
                    event.editor.view.state.selection.$head.parent.textContent;
                const currentNodeContentChildNodes =
                    event.editor.view.state.selection.$head.parent.content.size;
                const currentNodeDepth = event.editor.view.state.selection.$head.depth;
                const position = event.editor.view.state.selection.$head.pos - 1;
                const editorDomNode = event.editor.view.dom;
                const parent = getParent(event.editor.contentComponent);
                let inputElement = editorDomNode.querySelector('.sellsy-ai-writer__input');

                if (
                    !currentNodeContent &&
                    currentNodeContentChildNodes === 0 &&
                    currentNodeDepth === 1 &&
                    (parent?.$refs.refEmailPanelRichText ||
                        parent?.$refs.refSettingsEmailsTemplatesFormRichTextMessage) &&
                    !inputElement
                ) {
                    event.editor.commands.insertContentAt(position, '<SellsyAIInput />');

                    inputElement = editorDomNode.querySelector('.sellsy-ai-writer__input');

                    inputElement && !inputElement.disabled
                        ? inputElement.focus()
                        : event.editor.commands.blur();

                    const hashEmailPanel = parent?.$refs.refEmailPanelRichText?.getHash;
                    const hashSettingsEmailTemplate = parent?.getHash;
                    const storeKey = hashEmailPanel ?? hashSettingsEmailTemplate;

                    window.sellsyapp.$store.state[storeKey].coords.input = position;
                    return true;
                }
                return false;
            },
        };
    },

    addCommands() {
        return {
            insertText:
                (content) =>
                ({ tr, commands }) => {
                    const { $from } = tr.selection;
                    const from = tr.mapping.map($from.pos);
                    commands.insertContentAt(from, content, {
                        parseOptions: {
                            preserveWhitespace: 'full',
                        },
                    });
                    return true;
                },
            getEndSelection:
                () =>
                ({ tr }) => {
                    const { $to } = tr.selection;
                    const finalCoord = $to.depth === 1 ? $to.pos : $to.after(1);
                    return finalCoord;
                },
        };
    },
});

export default CustomSellsyAI;
